import React, { useMemo } from 'react'
import { Tag } from 'antd'

export enum EStatus {
  active = 'active',
  disabled = 'disabled',
}

const statusMap: Record<EStatus, string> = {
  active: 'เปิดใช้งาน',
  disabled: 'ระงับการใช้งาน',
}

const colorMap: Record<EStatus, string> = {
  active: '#87d068',
  disabled: '#f50',
}

interface Props {
  isAvailable: boolean
}

const UserStatusTag = (props: Props) => {

  const { isAvailable } = props

  const { color, text } = useMemo(() => {
    return {
      text: isAvailable ? statusMap[EStatus.active] : statusMap[EStatus.disabled],
      color: isAvailable ? colorMap[EStatus.active] : colorMap[EStatus.disabled],
    }
  }, [isAvailable])
  return (
    <Tag color={color} style={{ margin: 0 }} >
      {text}
    </Tag>
  )
}

export default UserStatusTag
